/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web_js'
 *
 * Required dependencies: @amplitude/analytics-browser@2.31.0
 * Tracking Plan Version: 3
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/toogoodtogo/Website/implementation/web_js)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'website';

export const ApiKey: Record<Environment, string> = {
  website: '3a53a39818e6654a436ca63848f2721b'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '3',
    branch: 'main',
    source: 'web_js',
    versionId: 'c054cf87-e096-4fd2-85b1-b68eb9a6b322'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  app_os?: string;
  available_item_ct?: string;
  country_iso_code?: string;
  dclid?: string;
  fbclid?: string;
  gbraid?: string;
  gclid?: string;
  initial_dclid?: string;
  initial_fbclid?: string;
  initial_gbraid?: string;
  initial_gclid?: string;
  initial_ko_click_id?: string;
  initial_li_fat_id?: string;
  initial_msclkid?: string;
  initial_referrer?: string;
  initial_referring_domain?: string;
  initial_rtd_cid?: string;
  initial_ttclid?: string;
  initial_twclid?: string;
  initial_utm_campaign?: string;
  initial_utm_content?: string;
  initial_utm_id?: string;
  initial_utm_medium?: string;
  initial_utm_source?: string;
  initial_utm_term?: string;
  initial_wbraid?: string;
  item_id?: string;
  li_fat_id?: string;
  msclkid?: string;
  referrer?: string;
  referring_domain?: string;
  sold_out?: string;
  store_id?: string;
  ttclid?: string;
  twclid?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_id?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
  wbraid?: string;
}

export interface DownloadAppProperties {
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   */
  "[Amplitude] Page URL"?: any;
  /**
   * Captures the operating system required for the downloaded app
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | APPLE_STORE, GOOGLE_PLAY_STORE, HUAWEI_STORE |
   */
  app_os?: "APPLE_STORE" | "GOOGLE_PLAY_STORE" | "HUAWEI_STORE";
}

export interface FindItemsProperties {
  /**
   * Count of distinct available items with supply (ie not sold out and not 'nothing today') - on surprise bag finder page
   */
  available_item_ct?: string;
  /**
   * Surprise bag find - count of items returned by the api call
   */
  item_displayed_ct?: string;
}

export interface FormErrorProperties {
  "[Amplitude] Form Destination"?: any;
  "[Amplitude] Form ID"?: any;
  error_type?: string;
}

export interface HowTgtgWorksWidgetProperties {
  /**
   * Part of the 'how it works' widget, counts the slide the user has clicked through to understand the TGTG process
   */
  how_tgtg_works_page_number?: string;
}

export interface ItemSearchResultsFilterProperties {
  /**
   * Name of the filter being used
   */
  filter?: any;
}

export interface ItemViewedProperties {
  /**
   * Unique identifier associated with AB Test
   */
  ab_test_id?: string;
  /**
   * Is ab test 'variant' or 'control'
   */
  ab_test_variant?: string;
  country_iso_code?: string;
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface ListViewItemClickProperties {
  /**
   * Unique identifier associated with AB Test
   */
  ab_test_id?: string;
  /**
   * Is ab test 'variant' or 'control'
   */
  ab_test_variant?: string;
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface MapClickProperties {
  /**
   * Associated with map - identifies the page of click origin
   */
  item_page?: string;
}

export interface MapViewItemBrowseProperties {
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface MapViewItemClickProperties {
  /**
   * Unique identifier associated with AB Test
   */
  ab_test_id?: string;
  /**
   * Is ab test 'variant' or 'control'
   */
  ab_test_variant?: string;
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface MystoreLoginProperties {
  /**
   * High level ENUM page type identifier - e.g. "home page", "blog page", "careers page"
   */
  page_type: string;
}

export interface ReserveFromWebsiteDesktopProperties {
  /**
   * Unique identifier associated with AB Test
   */
  ab_test_id?: string;
  /**
   * Is ab test 'variant' or 'control'
   */
  ab_test_variant?: string;
  country_iso_code?: string;
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface ReserveFromWebsiteMobileProperties {
  /**
   * Unique identifier associated with AB Test
   */
  ab_test_id?: string;
  /**
   * Is ab test 'variant' or 'control'
   */
  ab_test_variant?: string;
  country_iso_code?: string;
  /**
   * surprise bag unique ID
   */
  item_id?: string;
  sold_out?: boolean;
  store_id?: string;
}

export interface ScrollDepthReachedProperties {
  "[Amplitude] Page Domain"?: any;
  "[Amplitude] Page Location"?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type": string;
  /**
   * High level ENUM page type identifier - e.g. "home page", "blog page", "careers page"
   */
  page_type: string;
  /**
   * The scroll depth milestone reached
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  scroll_depth_percent?: number;
}

export interface SearchLocationProperties {
  /**
   * Optional string value which shows the context of the surprise bag search (which web UI, triggered the saerch)
   */
  search_context?: string;
  /**
   * A location search string used in the input on the surprise bag finder page
   */
  search_location_text?: string;
}

export interface SingleSignUpProperties {
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   */
  "[Amplitude] Page URL"?: any;
  /**
   * High level ENUM page type identifier - e.g. "home page", "blog page", "careers page"
   */
  page_type: string;
}

export interface DefaultProperties {
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   */
  "[Amplitude] Page URL"?: any;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DownloadApp implements BaseEvent {
  event_type = 'download_app';

  constructor(
    public event_properties?: DownloadAppProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FindItems implements BaseEvent {
  event_type = 'find_items';

  constructor(
    public event_properties?: FindItemsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FormError implements BaseEvent {
  event_type = 'form_error';

  constructor(
    public event_properties?: FormErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HowTgtgWorksWidget implements BaseEvent {
  event_type = 'how_tgtg_works_widget';

  constructor(
    public event_properties?: HowTgtgWorksWidgetProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItemSearchResultsFilter implements BaseEvent {
  event_type = 'item_search_results_filter';

  constructor(
    public event_properties?: ItemSearchResultsFilterProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItemViewed implements BaseEvent {
  event_type = 'item_viewed';

  constructor(
    public event_properties?: ItemViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListViewItemClick implements BaseEvent {
  event_type = 'list_view_item_click';

  constructor(
    public event_properties?: ListViewItemClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MapClick implements BaseEvent {
  event_type = 'map_click';

  constructor(
    public event_properties?: MapClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MapViewItemBrowse implements BaseEvent {
  event_type = 'map_view_item_browse';

  constructor(
    public event_properties?: MapViewItemBrowseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MapViewItemClick implements BaseEvent {
  event_type = 'map_view_item_click';

  constructor(
    public event_properties?: MapViewItemClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MystoreLogin implements BaseEvent {
  event_type = 'mystore_login';

  constructor(
    public event_properties: MystoreLoginProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReserveFromWebsiteDesktop implements BaseEvent {
  event_type = 'reserve_from_website_desktop';

  constructor(
    public event_properties?: ReserveFromWebsiteDesktopProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReserveFromWebsiteMobile implements BaseEvent {
  event_type = 'reserve_from_website_mobile';

  constructor(
    public event_properties?: ReserveFromWebsiteMobileProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScrollDepthReached implements BaseEvent {
  event_type = 'scroll_depth_reached';

  constructor(
    public event_properties: ScrollDepthReachedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchLocation implements BaseEvent {
  event_type = 'search_location';

  constructor(
    public event_properties?: SearchLocationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SingleSignUp implements BaseEvent {
  event_type = 'single_sign_up';

  constructor(
    public event_properties: SingleSignUpProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * download_app
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/download_app)
   *
   * Tracks app downloads from website
   *
   * @param properties The event's properties (e.g. [Amplitude] Page URL)
   * @param options Amplitude event options.
   */
  downloadApp(
    properties?: DownloadAppProperties,
    options?: EventOptions,
  ) {
    return this.track(new DownloadApp(properties), options);
  }

  /**
   * find_items
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/find_items)
   *
   * Triggered when the user has searched for a location - used on the surprise bag finder page
   *
   * Owner: Richard Manley
   *
   * @param properties The event's properties (e.g. available_item_ct)
   * @param options Amplitude event options.
   */
  findItems(
    properties?: FindItemsProperties,
    options?: EventOptions,
  ) {
    return this.track(new FindItems(properties), options);
  }

  /**
   * form_error
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/form_error)
   *
   * Event to show errors coming from a form submit failure
   *
   * Owner: Richard Manley
   *
   * @param properties The event's properties (e.g. [Amplitude] Form Destination)
   * @param options Amplitude event options.
   */
  formError(
    properties?: FormErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormError(properties), options);
  }

  /**
   * how_tgtg_works_widget
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/how_tgtg_works_widget)
   *
   * The website surprise bag page has a widget which explains to new uses how TGTG works and the process to pick up a surprise bag. This event fires when a user clicks through the 'slides' explaining how TGTG works
   *
   * @param properties The event's properties (e.g. how_tgtg_works_page_number)
   * @param options Amplitude event options.
   */
  howTgtgWorksWidget(
    properties?: HowTgtgWorksWidgetProperties,
    options?: EventOptions,
  ) {
    return this.track(new HowTgtgWorksWidget(properties), options);
  }

  /**
   * item_search_results_filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/item_search_results_filter)
   *
   * This event is fired when a filter has been used on the surprise bag find page
   *
   * @param properties The event's properties (e.g. filter)
   * @param options Amplitude event options.
   */
  itemSearchResultsFilter(
    properties?: ItemSearchResultsFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItemSearchResultsFilter(properties), options);
  }

  /**
   * item_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/item_viewed)
   *
   * Triggered when the user lands on a specific item page - on surprise bag finder page
   *
   * Owner: Richard Manley
   *
   * @param properties The event's properties (e.g. ab_test_id)
   * @param options Amplitude event options.
   */
  itemViewed(
    properties?: ItemViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItemViewed(properties), options);
  }

  /**
   * list_view_item_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/list_view_item_click)
   *
   * Event fired when a user clicks on the item card on the list view to click through to the item page
   *
   * @param properties The event's properties (e.g. ab_test_id)
   * @param options Amplitude event options.
   */
  listViewItemClick(
    properties?: ListViewItemClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListViewItemClick(properties), options);
  }

  /**
   * map_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/map_click)
   *
   * Tracking map interactivity on surprise bag pages and finder on the website
   *
   * @param properties The event's properties (e.g. item_page)
   * @param options Amplitude event options.
   */
  mapClick(
    properties?: MapClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MapClick(properties), options);
  }

  /**
   * map_view_item_browse
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/map_view_item_browse)
   *
   * Event fired when a user clicks on a store marker on the map, displaying the item card
   *
   * @param properties The event's properties (e.g. item_id)
   * @param options Amplitude event options.
   */
  mapViewItemBrowse(
    properties?: MapViewItemBrowseProperties,
    options?: EventOptions,
  ) {
    return this.track(new MapViewItemBrowse(properties), options);
  }

  /**
   * map_view_item_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/map_view_item_click)
   *
   * Event fired when a user clicks on the item card on the map view to click through to the item page
   *
   * @param properties The event's properties (e.g. ab_test_id)
   * @param options Amplitude event options.
   */
  mapViewItemClick(
    properties?: MapViewItemClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new MapViewItemClick(properties), options);
  }

  /**
   * mystore_login
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/mystore_login)
   *
   * Link clicks that go to MyStore login
   *
   * @param properties The event's properties (e.g. page_type)
   * @param options Amplitude event options.
   */
  mystoreLogin(
    properties: MystoreLoginProperties,
    options?: EventOptions,
  ) {
    return this.track(new MystoreLogin(properties), options);
  }

  /**
   * reserve_from_website_desktop
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/reserve_from_website_desktop)
   *
   * Surprise bag detail page - when a user scans a QR code to reserve bag on TGTG website. Hits a redirect endpoint, at which point this event fires before the endpoint directs to the deeplink on the app
   *
   * @param properties The event's properties (e.g. ab_test_id)
   * @param options Amplitude event options.
   */
  reserveFromWebsiteDesktop(
    properties?: ReserveFromWebsiteDesktopProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReserveFromWebsiteDesktop(properties), options);
  }

  /**
   * reserve_from_website_mobile
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/reserve_from_website_mobile)
   *
   * Surprise bag detail page - when a user clicks on button to reserve bag on TGTG website. Navigates user to appstore (if app not already installed) or to item page if app is installed
   *
   * Owner: Richard Manley
   *
   * @param properties The event's properties (e.g. ab_test_id)
   * @param options Amplitude event options.
   */
  reserveFromWebsiteMobile(
    properties?: ReserveFromWebsiteMobileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReserveFromWebsiteMobile(properties), options);
  }

  /**
   * scroll_depth_reached
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/scroll_depth_reached)
   *
   * An eventThis event represents the user scrolling to a specific depth on a webpage. It is triggered when the user reaches predefined vertical scroll thresholds, such as 25%, 50%, 75%, or 100% of the page height. This event helps track user engagement with page content.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scrollDepthReached(
    properties: ScrollDepthReachedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScrollDepthReached(properties), options);
  }

  /**
   * search_location
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/search_location)
   *
   * Triggered when user has entered an item/store they want to find and triggers search (on the surprise bag finder)
   *
   * @param properties The event's properties (e.g. search_context)
   * @param options Amplitude event options.
   */
  searchLocation(
    properties?: SearchLocationProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchLocation(properties), options);
  }

  /**
   * single_sign_up
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/Website/events/main/latest/single_sign_up)
   *
   * Tracks business leads conversion to mystore
   *
   * Owner: Richard Manley
   *
   * @param properties The event's properties (e.g. [Amplitude] Page URL)
   * @param options Amplitude event options.
   */
  singleSignUp(
    properties: SingleSignUpProperties,
    options?: EventOptions,
  ) {
    return this.track(new SingleSignUp(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
